// extracted by mini-css-extract-plugin
export default {"container":"KcNVUs","seatDetails":"oj2SsR"};